<div mat-dialog-title>
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button *ngIf="modalData.isEdit">
      <img src="../../../../assets/delete.png" style="width: 20px; margin-left: 5px;" (click)="deleteNode()">
    </button>
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
  <div style="padding-left: 15px; width: 80%; white-space: nowrap; overflow:hidden !important; text-overflow: ellipsis">
    {{ modalData.title }}
  </div>
</div>

<mat-dialog-content id="lifedi-modal" class="mat-typography pb-4">

  <div *ngIf="!modalData.isEdit">
    <form [formGroup]="addNodeForm">
      <div class="form-group row">
        <label class="col-3 col-form-label">ชื่อคอร์ส</label>
        <select class="col-9 custom-select form-control" style="display: inline;" (change)="selectCourse($event)">
          <option selected value="null">เลือกคอร์ส</option>
          <option *ngFor="let c of modalData.allCourse" [value]="c.COURSE_ID">{{ c.COURSE_NAME }}</option>
        </select>
      </div>
      <h6 class="text-center">
        หรือ
      </h6>
      <div class="form-group row">
        <input type="text" class="col-12 form-control" formControlName="input" placeholder="พิมพ์ชื่อคอร์ส">
      </div>
    </form>
    <p class="text-center text-danger">เลือกใส่เพียง 1 ค่า</p>
  </div>


  <div *ngIf="modalData.isEdit">
    <h6 class="text-center">
      คอร์สถัดไป
    </h6>
    <div [formGroup]="addLinkForm">
      <div *ngFor="let link of addLinkForm.get('links')['controls']; let i = index" formArrayName="links">
        <div [formGroupName]="i" class="form-group row">
          <select class="offset-1 col-9 custom-select form-control" style="display: inline;" formControlName="target"
            (change)="selectLink($event, i)">
            <option selected disabled hidden value="">เลือกคอร์ส</option>
            <option *ngFor="let n of allActiveNode" [value]="n.id">
              {{ n.label }}
            </option>
          </select>
          <div class="col-2">
            <button mat-mini-fab class="img" (click)="removeLink(i)"
              [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'"></button>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mb-3">
      <button mat-mini-fab class="img" (click)="addNewLinks()"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>
    </div>
  </div>
</mat-dialog-content>

<div *ngIf="!modalData.isEdit" align="center" style="padding-bottom: 20px; margin-right: 10px;">
  <div *ngIf="modalData.teachers?.length > 0">
    <lifedi-btn *ngIf="addNodeForm.value.selected  || addNodeForm.value.input" [lable]="modalData.actionBtnText"
      (click)="createNode(addNodeForm.value)" customStyle="background: #3E8C1A; color: #fff">
    </lifedi-btn>
    <lifedi-btn *ngIf="!addNodeForm.value.selected && !addNodeForm.value.input" [lable]="modalData.actionBtnText"
      [disabled]="true" customStyle="color: #fff">
    </lifedi-btn>
  </div>

  <div *ngIf="modalData.teachers?.length === 0">
    <small class="text-danger">กรุณาเลือกอาจารย์</small>
  </div>
</div>

<div *ngIf="modalData.isEdit" align="center" style="padding-bottom: 20px; margin-right: 10px;">
  <lifedi-btn *ngIf="addLinkForm.valid" [lable]="modalData.actionBtnText" (click)="createLinks(addLinkForm.value)"
    customStyle="background: #3E8C1A; color: #fff">
  </lifedi-btn>

  <lifedi-btn *ngIf="!addLinkForm.valid" [lable]="modalData.actionBtnText" [disabled]="true" customStyle="color: #fff">
  </lifedi-btn>
</div>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>
